import Api from './api';
import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadWarranties(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const warranty = getState().document.warrantyData.warranty[key];
    if (warranty) {
      loading = warranty.loading;
      loaded = warranty.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_WARRANTIES_DATA_STARTED, id: key });
      const warrantyData = await dispatch(sendHttpRequest(Api.getWarrantyData(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_WARRANTIES_DATA_SUCCESS, payload: warrantyData, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadWarrantiesSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const warrantySummary = getState().document.warrantyData.warrantySummary[key];
    if (warrantySummary) {
      loading = warrantySummary.loading;
      loaded = warrantySummary.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_WARRANTIES_SUMMARY_STARTED, id: key });
      const warrantySummayData = await dispatch(sendHttpRequest(Api.getWarrantySummaryData(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_WARRANTIES_SUMMARY_SUCCESS, payload: warrantySummayData, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadWarrantyItems(warrantyTypeId, search) {
  return () => Api.getWarrantyItems(search, warrantyTypeId);
}

export function updateWarranties(documentId, siteId, warranties) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(Api.updateWarranties(documentId, siteId, warranties), 'UpdateDocumentWarranties', [
          eventTypes.DOCUMENT_WARRANTIES_UPDATED
        ])
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function deleteAllWarranties(documentId, siteId, warrantiesToBeDeleted) {
  return async dispatch => {
    if (warrantiesToBeDeleted.length > 0 || warrantiesToBeDeleted.some(x => x.warrantyId > 0)) {
      await dispatch(sendHttpRequest(Api.deleteAllWarranties(documentId, siteId)));
    }

    dispatch({ type: actionTypes.ALL_WARRANTIES_DELETED, id: `${documentId}-${siteId}` });
  };
}

export function deleteWarranty(documentId, siteId, warrantyId) {
  return async dispatch => {
    if (!warrantyId) return;

    if (warrantyId > 0) {
      await dispatch(sendHttpRequest(Api.deleteWarranty(documentId, siteId, warrantyId)));
    }

    dispatch({ type: actionTypes.WARRANTY_DELETED, id: `${documentId}-${siteId}`, warrantyId: warrantyId });
  };
}

export function getWarrantyIssuer(documentId, siteId, issuerTypeId) {
  return async dispatch => {
    try {
      const warrantyIssuer = await dispatch(sendHttpRequest(Api.getWarrantyIssuer(documentId, siteId, issuerTypeId)));
      return warrantyIssuer;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
